import { Injectable } from '@angular/core';
import { LazyTreeNode } from '@core/models/models';

@Injectable()
export class LazyTreeViewService {
    public nodeSelected: LazyTreeNode[] = [];
    public dragImage: any = null;

    resetNodeSelected() {
        this.nodeSelected = [];
        this.dragImage = null;
    }
}
